import { defineComponent as _defineComponent } from 'vue'
import { ref, toRefs, watch } from '@nuxtjs/composition-api';
import { Metaverses } from '~/core/constants/affility/global/Metaverses';

interface Props {
    showSuffix?: boolean,
    suffixFormatter?: Function,
    currentMetaverse?: typeof Metaverses[keyof typeof Metaverses],
    availableMetaverses?: typeof Metaverses[keyof typeof Metaverses][],
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Metaverses',
  props: {
    showSuffix: { type: Boolean },
    suffixFormatter: { type: Function, default: (metaverse: typeof Metaverses[keyof typeof Metaverses]) => `/${metaverse.id}` },
    currentMetaverse: null,
    availableMetaverses: null
  },
  emits: ['metaverse-click'],
  setup(__props: any, { expose, emit: $emit }) {

const props = __props as { showSuffix?: boolean, suffixFormatter: Function, currentMetaverse?: typeof Metaverses[keyof typeof Metaverses], availableMetaverses?: typeof Metaverses[keyof typeof Metaverses][] };

const metaverseButtons = ref<HTMLButtonElement[] | null>(null);
expose({ metaverseButtons });




const {
    showSuffix,
    suffixFormatter,
    currentMetaverse,
    availableMetaverses,
} = toRefs(props);


return { __sfc: true,metaverseButtons, $emit, props, showSuffix, suffixFormatter, currentMetaverse, availableMetaverses }
}

})